import React from 'react';
import Select from 'react-select';

import {
  FormField,
  Label,
  Row,
  selectorProps,
} from '../../common/form';
import FundContext from './context';

export default function Manager() {
  const { state: { manager, fund: { members } }, dispatch } = React.useContext(FundContext);
  const options = [{ value: null, label: 'Not Assigned' }, ...(members || [])];

  const handleChange = selected => {
    dispatch({ type: 'setManager', payload: selected.value ? selected : null });
  };

  return (
    <Row>
      <Label htmlFor="manager">show as respondent</Label>
      <FormField>
        <Select
          {...selectorProps}
          className="manager"
          value={manager}
          options={options}
          onChange={handleChange}
        />
      </FormField>
    </Row>
  );
}
